import * as React from 'react'
import { useQuery } from 'react-query'
import getEnrolledCards from '@/src/card-linking/queries/GetEnrolledCards'

const useGetEnrolledCards = (cardLinkSessionId: string) => {
    return useQuery(
        ['postCardLinkSession', { cardLinkSessionId }],
        getEnrolledCards,
        {
            enabled: Boolean(cardLinkSessionId),
            retry: 1,
            // @ts-ignore
            refetchOnWindowFocus: false,
        }
    )
}

export default useGetEnrolledCards
